import { PartialMessage } from "@bufbuild/protobuf";

import type {
  AuthenticationConfiguration,
  SsoDomain,
} from "@safetyculture/s12-apis-connect-web/s12/common/api_identity_pb";
import {
  GetOrgsForConnectionNameRequest,
  GetOrgsForConnectionNameResponse,
  OrgSsoSettings,
} from "@safetyculture/s12-apis-connect-web/s12/identity/admin/v1/idp_pb";
import {
  CopySsoConfigurationAdminRequest,
  CopySsoConfigurationAdminResponse,
  CreateSsoTicketAdminRequest,
  CreateSsoTicketAdminResponse,
  DeleteSsoConfigurationAdminRequest,
  DeleteSsoConfigurationAdminResponse,
  GetSsoConfigurationAdminRequest,
  GetSsoConfigurationAdminResponse,
  RecreateSsoTicketAdminRequest,
  RecreateSsoTicketAdminResponse,
  UpdateSsoConfigurationAdminRequest,
  UpdateSsoConfigurationAdminResponse,
} from "@safetyculture/s12-apis-connect-web/s12/identity/admin/v1/sso_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

export type SsoAdminData = {
  authConf?: AuthenticationConfiguration;
  otherOrgSettings: OrgSsoSettings[];
};

export const getSsoConfigurationAdmin = async (
  { orgId }: { orgId: string },
  headers: Record<RequestMetadata, string>
): Promise<GetSsoConfigurationAdminResponse> => {
  const req = new GetSsoConfigurationAdminRequest({ orgId });
  return supportServiceConnectClient.getSsoConfigurationAdmin(req, { headers });
};

export const createSsoTicketAdmin = async (
  { orgId, ssoDomains }: { orgId: string; ssoDomains: SsoDomain[] },
  headers: Record<RequestMetadata, string>
): Promise<CreateSsoTicketAdminResponse> => {
  const req = new CreateSsoTicketAdminRequest({ orgId, ssoDomains });
  return supportServiceConnectClient.createSsoTicketAdmin(req, { headers });
};

export const recreateSsoTicketAdmin = async (
  { orgId }: { orgId: string },
  headers: Record<RequestMetadata, string>
): Promise<RecreateSsoTicketAdminResponse> => {
  const req = new RecreateSsoTicketAdminRequest({ orgId });
  return supportServiceConnectClient.recreateSsoTicketAdmin(req, { headers });
};

export const deleteSsoConfigurationAdmin = async (
  { orgId }: { orgId: string },
  headers: Record<RequestMetadata, string>
): Promise<DeleteSsoConfigurationAdminResponse> => {
  const req = new DeleteSsoConfigurationAdminRequest({ orgId });
  return supportServiceConnectClient.deleteSsoConfigurationAdmin(req, {
    headers,
  });
};

export const updateSsoConfigurationAdmin = async (
  authConf: PartialMessage<AuthenticationConfiguration>,
  headers: Record<RequestMetadata, string>
): Promise<UpdateSsoConfigurationAdminResponse> => {
  const req = new UpdateSsoConfigurationAdminRequest({ authConf });
  return supportServiceConnectClient.updateSsoConfigurationAdmin(req, {
    headers,
  });
};

export const copySsoConfigurationAdmin = async (
  { sourceOrgId, targetOrgId }: { sourceOrgId: string; targetOrgId: string },
  headers: Record<RequestMetadata, string>
): Promise<CopySsoConfigurationAdminResponse> => {
  const req = new CopySsoConfigurationAdminRequest({
    sourceOrgId,
    targetOrgId,
  });
  return supportServiceConnectClient.copySsoConfigurationAdmin(req, {
    headers,
  });
};

export const getOrgsForConnectionName = async (
  { connectionName }: PartialMessage<GetOrgsForConnectionNameRequest>,
  headers: Record<RequestMetadata, string>
): Promise<GetOrgsForConnectionNameResponse> => {
  const req = new GetOrgsForConnectionNameRequest({
    connectionName,
  });

  return supportServiceConnectClient.getOrgsForConnectionName(req, { headers });
};
